import { ClipSource } from './clipSource'

import { postClipMiss } from '../../utils/readAloudAPIs'

const MISS_REASON = 'missing'
const reported = new Set<string>()
let activitySessionUid: string | null = null

const ignore = () => undefined

export const setClipMissSession = (uid: string | null | undefined) => { activitySessionUid = uid || null }

export const reportClipMiss = (source: ClipSource, textHash: string): Promise<void> => {
  const key = [source.type, source.id, textHash].join('|')
  if (reported.has(key)) { return Promise.resolve() }

  reported.add(key)
  const session = activitySessionUid ? { activity_session_uid: activitySessionUid, } : {}
  return postClipMiss({ reason: MISS_REASON, source_id: source.id, source_type: source.type, text_hash: textHash, ...session, }).then(ignore, ignore)
}

export const resetClipMissReports = () => {
  reported.clear()
  activitySessionUid = null
}
